"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ResultCode = _interopRequireDefault(require("./ResultCode"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The ErrorResponse model module.
 * @module model/ErrorResponse
 * @version 1.1.3-alpha.1
 */
class ErrorResponse {
  /**
   * Constructs a new <code>ErrorResponse</code>.
   * @alias module:model/ErrorResponse
   */
  constructor() {
    ErrorResponse.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>ErrorResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ErrorResponse} obj Optional instance to populate.
   * @return {module:model/ErrorResponse} The populated <code>ErrorResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ErrorResponse();
      if (data.hasOwnProperty('status')) {
        obj['status'] = _ApiClient.default.convertToType(data['status'], 'Number');
      }
      if (data.hasOwnProperty('errors')) {
        obj['errors'] = _ApiClient.default.convertToType(data['errors'], {
          'String': ['String']
        });
      }
      if (data.hasOwnProperty('message')) {
        obj['message'] = _ApiClient.default.convertToType(data['message'], 'String');
      }
      if (data.hasOwnProperty('error')) {
        obj['error'] = _ApiClient.default.convertToType(data['error'], Object);
      }
      if (data.hasOwnProperty('code')) {
        obj['code'] = _ResultCode.default.constructFromObject(data['code']);
      }
      if (data.hasOwnProperty('success')) {
        obj['success'] = _ApiClient.default.convertToType(data['success'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>ErrorResponse</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ErrorResponse</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
      throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
    }
    return true;
  }
}

/**
 * An error status (usually the HttpStatus code)
 * @member {Number} status
 */
ErrorResponse.prototype['status'] = undefined;

/**
 * Map of individual errors (usually corresponding to data fields)
 * @member {Object.<String, Array.<String>>} errors
 */
ErrorResponse.prototype['errors'] = undefined;

/**
 * An error message
 * @member {String} message
 */
ErrorResponse.prototype['message'] = undefined;

/**
 * @member {Object} error
 */
ErrorResponse.prototype['error'] = undefined;

/**
 * @member {module:model/ResultCode} code
 */
ErrorResponse.prototype['code'] = undefined;

/**
 * @member {Boolean} success
 */
ErrorResponse.prototype['success'] = undefined;
var _default = ErrorResponse;
exports.default = _default;